<div class="container">
  <div class="top-row">
    <div class="left">
      <div>
        <h4 class="heading-name-id">
          Search Transload Facility
        </h4>
      </div>

      <div class="dropdown-width">
        <lib-location-external-autocomplete #cityStateDropdown [isSubmitted]="isSubmitted" searchField [locationType]="'CITY_STATE'" [roleType]="'CITY_STATE'" [cityStateText]="true" [showErrors]="true" [placeHolder]="searchBy"  [required]="true" (selectedLocation)="onSelected($event, 'cityState')"
        >
        </lib-location-external-autocomplete>
      </div>
      <div class="top-width-chip">
        <lib-dropdown-chips #dropdownChip [isSubmitted]="isSubmitted" [fieldName]="fieldName" [required]="false" [options]="options" (selectedDropdownValue)="onSelected($event, 'radius')"></lib-dropdown-chips>
      </div>
      <div class="top-width button-top">
        <up-button button-style="contained" (click)="getSearchData()">
        Search
      </up-button>
      </div>
    </div>

    <!-- Desktop actions (hidden on mobile) -->
    <div class="right desktop-actions">
      <up-button button-style="outlined" (click)="openContact()">
        Contact us
      </up-button>
      <up-button button-style="contained" (click)="openExternalScreen()">
        Request a Quote
      </up-button>
    </div>
  </div>

  <!-- Map -->
  <div style="margin-top: 10px">
    <lib-here-map [markerPoints]="pinsList" [width]="'100%'" [smallScreen]="smallScreen" [height]="mapHeight" (selectionChanged)="onSelectionChanged($event)" #mapCmp > </lib-here-map>
  </div>

  <!-- Mobile sticky actions (hidden on desktop) -->
  <div class="mobile-cta">
    <button class="btn btn--ghost" (click)="openContact()">
      Contact Us
    </button>
    <button class="btn btn--primary" (click)="openExternalScreen()">
      Request a Quote
    </button>
  </div>
</div>

@if(contactOverlay){
  <lib-contact-details-overlay [isOverlayOpen]="contactOverlay" (closingeOverlay)="overlayClosed($event)"></lib-contact-details-overlay>
}
